<template>
  <div id="seminarCard-big" @click="$emit('selectedCard', dataMarker)" >
    <!-- <div class="catch-hub-phone d-flex justify-content-between align-items-start">
      <p class="merriweather-italic mb-0">
        {{ lodging.lodging_description && lodging.lodging_description.catch_sentence ? lodging.lodging_description.catch_sentence : "Un havre aussi éco-responsable que luxueux" }}
      </p>
      <div class="like-icon ml-2">
        <img 
          src="../../images/wishlistOn.svg" 
          v-set-alt 
          v-if="isIncludeInWishlist()" 
          @click="toggleLike()" 
        />
        <img 
          src="../../images/wishlist.svg" 
          v-set-alt 
          v-else 
          @click="toggleLike()" 
        />
      </div>
    </div> -->
    <div class="hub-img-zoom" @click="goToLodging()" :style="{ backgroundImage: 'url(' + formatSource() + ')' }">
      <div class="image-overlay"></div>
      <div class="experience-name-text merriweather-reg-24 no-translate" v-if="this.experienceName">
          {{ this.experienceName[0] }} <br>
          <span class="merriweather-bold-italic-24 no-translate">{{ this.experienceName[1] }}</span>
      </div>
      <div class="sticker-hub d-flex mt-4 pl-2" style="position: none;">
        <img :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score && !upHere" />
        <div class="sticker-info d-flex flex-column" v-if="lodging.score" @mouseover="upHere = true" @mouseleave="upHere = false">
          <div v-if="!isPhone" style="position:absolute; width: 426px;height: 425px;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;"  v-show="upHere">
            <div class="row pl-2">
              <div class="pl-3 ">
            <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
              </div>
            <p class="raleway-reg-p13 mb-0 pl-1 pr-2 sticky-font">
              <b>{{ lodging.score.toFixed() }}</b
              >/10
            </p>
            </div>
            <div class="pl-4">
            <div class="mt-1">
            <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
              LA GREEN NOTE
              </p>
            </div>
            <div class="pr-2">
              <p style="font: normal normal bold 13px/15px Raleway;">
                Pour être intégré à la sélection, un hébergement doit obtenir une note globale d’au moins 5 sur 10.</p>
            </div>
            <div class="pr-2">
            <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
              La Green Note, développée par Hortense, est un outil de scoring qui vise à évaluer le niveau d’engagement environnemental des hébergements. Elle se base sur 10 critères d’éco-responsabilité pour attribuer une note sur 10 à chaque critère, ainsi qu’une note globale à l’hébergement, allant de 1 à 10.<br></br> Pour être intégré à la sélection, un hébergement doit obtenir une note globale d’au moins 5 sur 10. Cela signifie que l’établissement doit démontrer un engagement significatif dans des pratiques éco-responsables et répondre aux critères établis par la Green Note.<br></br> Les 10 critères d’éco-responsabilité pris en compte dans l’évaluation incluent des aspects tels que la gestion des déchets, l’efficacité énergétique, l’utilisation de sources d’énergie renouvelables, la conservation de l’eau, la promotion du transport durable, l’utilisation de matériaux écologiques, la sensibilisation à l’environnement, la formation du personnel aux éco-gestes etc.<br></br> En utilisant la Green Note, Hortense vise à encourager les hébergements à adopter des pratiques plus respectueuses de l’environnement et à aider les voyageurs à faire des choix plus durables en matière d’hébergement.</p>
            </div>
          </div>
          </div>
          <div v-if="isPhone" style="position:fixed;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A5D3AE;border-radius: 0px 53px 53px 0px;opacity: 1;" v-show="upHere">
            <div class="row pl-2">
              <div class="pl-3 ">
                <img style="width: 14px;height: 21px;" :src="greenNotePicto(lodging.score.toFixed())" :alt="lodging.score.toFixed()" v-if="lodging.score" />
              </div>
              <p class="raleway-reg-p13 mb-0 pl-1 pr-2 sticky-font">
                <b>{{ lodging.score.toFixed() }}</b
                >/10
              </p>
            </div>
            <div class="pl-4">
              <div class="mt-2">
                <p style="text-align: left;font: normal normal bold 13px/15px Raleway;letter-spacing: 0px;color: #000000;text-transform: uppercase;opacity: 1;">
                  LA GREEN NOTE
                </p>
              </div>
              <div class="mt-3 pr-2">
                <p style="font: normal normal bold 13px/15px Raleway;">
                  Pour être intégré à la sélection, un hébergement doit obtenir une note globale d’au moins 5 sur 10.</p>
              </div>
              <div class="mt-2 pr-2">
                <p style="text-align: left;font: normal normal normal 12px/14px Raleway;letter-spacing: 0px;color: #000000;opacity: 1;">
                  La Green Note, développée par Hortense, est un outil de scoring qui vise à évaluer le niveau d’engagement environnemental des hébergements. Elle se base sur 10 critères d’éco-responsabilité pour attribuer une note sur 10 à chaque critère, ainsi qu’une note globale à l’hébergement, allant de 1 à 10.<br></br> Pour être intégré à la sélection, un hébergement doit obtenir une note globale d’au moins 5 sur 10. Cela signifie que l’établissement doit démontrer un engagement significatif dans des pratiques éco-responsables et répondre aux critères établis par la Green Note.<br></br> Les 10 critères d’éco-responsabilité pris en compte dans l’évaluation incluent des aspects tels que la gestion des déchets, l’efficacité énergétique, l’utilisation de sources d’énergie renouvelables, la conservation de l’eau, la promotion du transport durable, l’utilisation de matériaux écologiques, la sensibilisation à l’environnement, la formation du personnel aux éco-gestes etc.<br></br> En utilisant la Green Note, Hortense vise à encourager les hébergements à adopter des pratiques plus respectueuses de l’environnement et à aider les voyageurs à faire des choix plus durables en matière d’hébergement.</p>
              </div>
            </div>
          </div>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2">
            <b>{{ lodging.score.toFixed() }}</b
            >/10
          </p>
          <p class="raleway-reg-p13 mb-0 pl-1 pr-2 sticky-font">Green note</p>
        </div>
      </div>
    </div>
    <div class="card-hub-info">
      <div class="hub-header d-flex">
        <h2 class="raleway-bold-h3 mt-2 no-translate">{{ lodging.name }}</h2>
				<div v-if="lodging.standing && parseInt(lodging.standing) > 0" class="standing ml-2">
					<img src="../../images/Etoiles.svg" v-set-alt v-if="lodging.standing" v-for="i in Math.max(0, parseInt(lodging.standing) || 0)" :key="i" />
					<img v-if="lodging.standing && parseInt(lodging.standing) > 0" src="../../images/blanc.png" alt="white" />
      	</div>
      </div>
      <div v-if="showMapfind" class="mobile-map-modal">
        <Mapfind :markers="markers" :lodgings="lodgingList" :selectedLodgingId="lodging.id" @close="closeMap" />
      </div>
      <p class="description-hub raleway-reg-p13" v-if="fullLocation">{{ fullLocation }}</p>
      <p class="raleway-reg-p13">
          Cet établissement propose {{ this.lodging.number_of_room }} {{ this.lodging.number_of_room == 1 ? 'chambre' : 'chambres' }}
      </p>
    </div>
  </div>
  </template>
  
  <script>
  import fetcher from 'packs/shared/api.js';
  import Cardmap from 'components/cards/Cardmap.vue';
  import Maptest from 'components/Maptest.vue';
  import Mapfind from 'components/Mapfind.vue';
  
  export default {
    name: 'SeminarCard',
    props: ['lodging', 'dataMarker', 'user', 'exclusive', 'wishlistLodgings', 'showMapCard', 'to', 'from', 'lodgingList'],
    components: { Maptest, Cardmap, Mapfind },
    data() {
      return {
        lodgingMount: this.lodging,
        //wishlistLodgings: null,
        showMap: false,
        showMapfind: false,
        mapfindKey: 0,
        markers: [],
        ratedLodgings: [],
        averageList: [],
        average: '-',
        upHere: false,
        typeLabels: {
        Hotel: "Hôtels",
        "Maison et Villa": "Maisons et Villas",
        Guestroom: "Chambres d'Hôtes",
        Lodge: "Lodges et Lieux Insolites",
        Appartment: "Appartements",
        Chalet: "Chalets"
      }
      };
    },
    methods: {
        safeToFixed(score, digits = 1) {
					return typeof score === 'number' ? score.toFixed(digits) : '-';
        },

      goToLodging() {
        const urlParams = new URLSearchParams(window.location.search);
        const typeParam = urlParams.get('base');
        let newUrl = '/reservation-hotel/' + this.lodging.slug;
        if (typeParam === 'spring' || typeParam === 'summer') {
          newUrl += '?base=' + typeParam;
        }
        if (this.isPhone) {
          window.location.href = newUrl;
        } else {
          window.open(newUrl, '_blank');
        }
      },
      openInNewWindow(slug) {
        const urlParams = new URLSearchParams(window.location.search);
        const typeParam = urlParams.get('base');
        let newUrl = '/reservation-hotel/' + slug;
        if (typeParam === 'spring' || typeParam === 'summer') {
          newUrl += '?base=' + typeParam;
        }
        if (this.isPhone) {
          window.location.href = newUrl;
        } else {
          window.open(newUrl, '_blank');
        }
      },
      greenNotePicto(score) {
        if (score === `${score}`) {
          return require(`../../images/greennote ${score}.svg`);
        } else {
          return require('../../images/blanc.png');
        }
      },
      async toggleLike() {
        try {
          if (Object.entries(this.user).length !== 0) {
            const response = await fetcher.patch('/wishlists/' + this.user.id, { lodging_id: this.lodging.id });
            this.wishlistLodgings = response.data.lodgings;
            window.dataLayer.push({
              event : 'add_to_wishlist',
              ecommerce: {
                items: [{
                  item_name: this.lodging.name,
                  item_id: this.lodging.id,
                  item_city: this.lodging.city ? this.lodging.city.name : 'Pruniers-en-Sologne',
                  item_region: this.lodging && this.lodging.region ? this.lodging.region.name : 'Occitanie',
                  item_category: 'lodging',
                }]
              }
            });
          } else {
            this.$root.$emit('openModal');
            window.scrollTo({
              top: 0,
              behaviour: 'smooth',
            });
          }
        } catch (e) {
          console.error(e);
        }
      },
      displayMap() {
        this.showMap = !this.showMap;
        this.markers = this.markerMap();
      },
      displayMapfind() {
        console.log('[seminarCardBig] Triggered map open');
  
        this.closeMap();
        this.$emit('hideBigMap');
  
        // Clear previous map if exists
        if (this.mapInstance) {
          this.mapInstance.remove();
          this.mapInstance = null;
        }
  
        if (!Array.isArray(this.lodgingList) || this.lodgingList.length === 0) {
          console.warn('[seminarCardBig] lodgingList is empty or not an array');
          return;
        }
  
        // Filter out invalid entries
        this.markers = this.lodgingList
          .filter(l => l && typeof l.longitude === 'number' && typeof l.latitude === 'number')
          .map(l => [l.longitude, l.latitude, l.id, l.lowest_price]);
  
        this.mapfindKey += 1; // Force re-render
        this.showMapfind = true;
  
        // On mobile, scroll to top for full-screen modal
        if (this.isPhone) {
          document.body.classList.add('map-active', 'no-scroll');
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      closeMap() {
        if (this.mapInstance) {
          this.mapInstance.remove();
          this.mapInstance = null;
        }
        this.showMapfind = false;
        this.$emit('hideSmallMap');
  
        if (this.isPhone) {
          document.body.classList.remove('map-active');
        }
      },
      markerMap() {
        return [this.lodging.longitude, this.lodging.latitude];
      },
      formatSource() {
        if (this.lodging.photo_banner) {
          return this.lodging.photo_banner
        } else {
          return 'https://media.gettyimages.com/photos/bedroom-in-new-luxury-home-picture-id1194686012?k=6&m=1194686012&s=612x612&w=0&h=IX6Bjhwa5M5NtCtlKll-FFi_hn5lxrPwiUImH3fsZZ0=';
        }
      },
      openInNewWindow(slug) {
        const urlParams = new URLSearchParams(window.location.search);
        const typeParam = urlParams.get('base');
        let newUrl = '/reservation-hotel/' + slug;
        if (typeParam === 'spring' || typeParam === 'summer') {
          newUrl += '?base=' + typeParam;
        }
        if (this.isPhone) {
          window.location.href = newUrl;
        } else {
          window.open(newUrl, '_blank');
        }
      },
      openInNewWindowTwo(slug_one, slug_two) {
        window.open('/offres-exclusives/' + slug_one + '/' + slug_two, '_blank');
      },
      formatStyle(value) {
        return value.charAt(0).toUpperCase() + value.slice(1);
      },
      isIncludeInWishlist() {
        if (this.wishlistLodgings) {
          for (const lodging of this.wishlistLodgings) {
            if (lodging.id === this.lodging.id) {
              return true;
            }
          }
        }
        return false;
      },
      ratedLodging() {
        if (this.lodging.reservations && this.lodging.reservations.length !== 0) {
          this.ratedLodgings = this.lodging.reservations.filter((el) => el.rated === true);
        }
        return this.ratedLodgings;
      },
      averageRate() {
        this.ratedLodgings.forEach((el) => {
          this.averageList.push(el.rate_average);
        });
        return this.averageList;
      },
      averageLodging() {
        if (this.averageList.length > 0) {
          this.average = (this.averageList.reduce((a, b) => a + b, 0) / this.averageList.length).toFixed(1);
        } else {
          this.average = '-';
        }
      },
      async fetchWishlist() {
        //console.log('************', this.user);
        try {
          if (this.user) {
            const response = await fetcher.get('/wishlists.json');
            this.wishlistLodgings = response.data.lodgings;
          }
        } catch (e) {
          console.error(e);
        }
      },
      async fetchLodgings() {
        try {
          // const res = await fetcher.get('/lodgings/' + this.lodging.slug);
          // this.lodgingMount = res.data;
          this.ratedLodging();
          this.averageRate();
          this.averageLodging();
        } catch (e) {
          console.error(e);
        }
      },
    },
    mounted() {
      // console.log('[seminarCardBig] lodgingList passed:', this.lodgingList);
      this.fetchLodgings();
			console.log("🏨 Lodging data:", this.lodging);
      //this.fetchWishlist();
    },
    computed: {
  
      fullLocation() {
        const capitalize = (str) => {
          if (!str) return '';
          return str
            .split('-') // split on hyphens
            .map(part =>
              part
                .split(' ') // split on spaces within each hyphen part
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ')
            )
            .join('-');
        };

        const { country, region, department, city } = this.lodging;

        return [country?.name, region?.name, department?.name, city?.name]
          .filter(Boolean)
          .map(capitalize)
          .join(', ');
      },
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          console.log('User agent:', navigator.userAgent);
          return true;
        }else{
          console.log('User agent:', navigator.userAgent);
          return false;
        }
      },
      defineWishlistLodgings() {
        return (this.wishlistLodgings = this.wishlist.lodgings);
      },
      experienceName() {
        if (this.lodging.experience_name) {
          const words = this.lodging.experience_name.split('\n');
          const firstWord = words.shift();
          const restOfSentence = words.join(' ');
          return [firstWord, restOfSentence];
        } else {
          return null;
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scope="app/assets/stylesheets/components/card-product" scoped>
  .hub-img-zoom {
    position: relative;
    overflow: visible;
		margin-top: auto;
    margin-bottom: auto;
    width: 430px;
    height: 400px;
    margin-right: 1rem;
    cursor: pointer;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;

  }
	.sticker-hub{
		position: absolute;
    background-color: #fff;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    align-items: center;
    width: 35%;
    z-index: 1;
	}
  
  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  
  .mobile-map-modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
    background: white;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
  .experience-name-text {
      position: absolute;
      bottom: 10px;
      left: 10px;
      color: white;
      line-height: 110%;
      z-index: 2;
  }
	.sticky-font{
		font-size: 1rem;
	}
  
  .location-hub{
    display: block !important;
  }
  
  // @media(min-width: 486px){
  //   #map-find{
  //     #card-map.right{
  //       top: auto !important;
  //     }
  //   }
  // }
  #seminarCard-big{
    transform: none;
  }
  @media (max-width: 485px) {
    body.map-active #navbar-main .top-bar,
    body.map-active #navbar-main #nav-phone .nav-phone {
      z-index: 1 !important;
    }
  
    body.map-active .mobile-map-modal {
      z-index: 9999 !important;
    }
  
    #map-find .modal-mask {
      display: flex !important;
      flex-direction: column-reverse;
    }
    #map-find .modal-container{
      padding: 0px !important;
      margin: 0px !important;
      width: 98.4vw !important;
    }
    #map-find .closing{
      top: 0vh;
      margin: 0px;
    }
  }
  
  </style>